/* eslint-disable */
export default {
  mute: 'Ativar mudo',
  unmute: 'Desativar mudo',
  hangup: 'Desligar',
  reject: 'Rejeitar',
  hold: 'Colocar em espera',
  onHold: 'Em espera',
  transfer: 'Transferir',
  more: 'Mais',
  stopRecord: 'Parar gravação',
  record: 'Gravar',
  showKeypad: 'Teclado numérico',
  hideKeypad: 'Ocultar teclado numérico',
  unHold: 'Liberar',
  forward: 'Encaminhar',
  ignore: 'Ignorar',
  voicemail: 'Para caixa postal',
  custom: 'Personalizada',
  answerAndEnd: 'Atender e terminar',
  answerAndHold: 'Atender e colocar em espera',
  answer: 'Atender',
  completeTransfer: 'Concluir a transferência',
  reply: 'Responder',
  add: 'Adicionar',
  mergeCall: 'Mesclar com chamada ativa',
  endCallForEveryone: 'Encerrar chamada para todos',
  leaveCall: 'Sair da chamada',
  leaveOrEndCall: 'Sair ou encerrar chamada?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
